import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { payUserInvoice } from '../../actions/partner/partner';


export const RegleModal = ({ selectedUser }) => {

    const dispatch = useDispatch();
    const confirmButtonRef = useRef(null);

    async function handlePayInvoice(pendingInvoiceId) {
        try {
            await dispatch(payUserInvoice(pendingInvoiceId));
            confirmButtonRef.current.setAttribute("data-dismiss", "modal");
            confirmButtonRef.current.click();
            confirmButtonRef.current.removeAttribute("data-dismiss");
        } catch (error) {
            console.log(error);
        }
    }



    return (
        <div className="modal fade px-0" id="regleModal" aria-labelledby="regleModalLabel" aria-hidden="true">
            <div className="modal-dialog px-2 modal-sm">
                <div className="modal-content">
                    <header className="modal-header">
                        <div className="alert bg-alert-success rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
                            <h1 className="sr-only visually-hidden">Règlement actualisation</h1>
                            <div className="flex-row align-items-center justify-content-between">
                                <div className="h4 text-success text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="regleModalLabel">Règlement actualisation</div>
                                <button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
                                    <i className="eva eva-close fs-4"></i>
                                </button>
                            </div>
                        </div>
                    </header>
                    <div className="modal-body text-center scroll-default py-0">
                        <p className="h5 lh-copy">Vous allez confirmer que votre client souhaite poursuivre son dossier ANTICIPA et vous a réglé l'actualisation. Toute validation est définitive.</p>

                    </div>
                    <div className="modal-footer justify-content-center">
                        <button type="button" className="btn btn-faded" data-dismiss="modal" ref={confirmButtonRef}>Annuler</button>
                        <button type="submit" className="btn btn-success" onClick={async () => await handlePayInvoice(selectedUser.pendingInvoiceId)}>Confirmation</button>
                    </div>
                </div>
            </div>
        </div>
    );

};
